/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';
import pick from 'lodash/pick';

/**
 * Informace o jednom připojení k síti.
 * @implements {Serializable}
 */
class NetworkConnection {
  /**
   * Vytvoří instanci.
   * @param {string} mac MAC adresa.
   * @param {NetworkType} type Typ připojení.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {string} [opts.ip] IP adresa.
   * @returns {NetworkConnection} Nová instance.
   */
  constructor (mac, type, {ip = null} = {}) {
    this.ip = ip;
    this.mac = mac;
    this.type = type;
  }

  /**
   * Zjistí IP adresu připojení.
   * @returns {string} IP adresa.
   */
  getIp () {
    if (!this.hasIp()) {
      throw new TypeError('Missing IP adress.');
    }
    return this.ip;
  }

  /**
   * Zjistí MAC adresu připojení.
   * @returns {string} MAC adresa.
   */
  getMac () {
    return this.mac;
  }

  /**
   * Zjistí typ připojení.
   * @returns {NetworkType} Typ připojení.
   */
  getType () {
    return this.type;
  }

  /**
   * Zjistí, jestli má připojení přiděleno IP adresu.
   * @returns {boolean} Příznak.
   */
  hasIp () {
    return !isNil(this.ip);
  }

  /** @inheritdoc */
  toJSON () {
    return pick(this, 'ip', 'mac', 'type');
  }
}

export default NetworkConnection;
